module.exports = __webpack_public_path__ + "images/emoji/raised_hands.e90f40648a34590528a1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/raised_hands.png
// module id = sRpA
// module chunks = 2